// extracted by mini-css-extract-plugin
module.exports = {"twoLines":"Event_twoLines__3SBAZ"};